import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { PopUpsService } from '../pop-ups.service';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';

@Component({
  selector: 'app-pop-ups-cui',
  templateUrl: './pop-ups-cui.component.html',
  styleUrls: ['./pop-ups-cui.component.sass']
})
export class PopUpsCuiComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PopUpsCuiComponent>, 
    public popUpService: PopUpsService,
    public appInsightsService: AppInsightsService) { }

  ngOnInit() {
  }

  public checked = false;

  setValuePopUp(e: any){
    this.checked = e.detail
    if(this.checked == true){
      this.popUpService.checkBoxCui.next(true)
    }else{
      this.popUpService.checkBoxCui.next(false)
    }
  }

  closePopUp(){
    this.dialogRef.close('no');
    this.appInsightsService.trackEvent(Event.btnRejactedTerms);
    this.popUpService.checkBoxCui.next(false)
  }

  nextPopUp(){
    if(this.popUpService.checkBoxCui.value == true){
      this.appInsightsService.trackEvent(Event.btnAcceptTerms);
      this.dialogRef.close('yes');
      this.popUpService.checkBoxCui.next(true)
    }
  }

}
